import { ResolutionStatus, ResolutionStatusDisplayText } from "../models/benchly.models";

export function getResolutionStatusDisplayText(status: ResolutionStatus): string {
  return ResolutionStatusDisplayText[
    ResolutionStatus[status] as keyof typeof ResolutionStatusDisplayText
  ];
}
